<template>
  <div>
    <b-row class="mb-2">
      <b-col>
        <span>Templates</span>
      </b-col>
    </b-row>
    <b-row v-if="templates.length" class="mb-2">
      <b-col>
        <treeselect v-model="selectedTemplate" size="sm" :options="filteredTemplates" :disable-branch-nodes="true"
                    :show-count="true"
                    @input="emitSelectedTemplate">
          <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                 :class="labelClassName">
            <span :title="node.label"><b-icon-folder v-if="node.isBranch" scale="0.8" class="mr-1"/> {{
                node.label
              }}</span>
            <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
          </label>
          <div slot="value-label" slot-scope="{ node }">{{ node.raw.name }}</div>
        </treeselect>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button size="sm" variant="outline-primary" @click="confirmSaveTemplate">
          <b-icon-plus/>
        </b-button>
        <b-button v-if="currentTemplate" class="ml-2" size="sm" variant="outline-primary" @click="confirmEditTemplate">
          <b-icon-pencil/>
        </b-button>
        <b-button v-if="currentTemplate" class="ml-2" size="sm" variant="outline-primary" @click="removeTemplate">
          <b-icon-trash/>
        </b-button>
      </b-col>
    </b-row>

    <b-modal v-model="modalSaveTemplate" button-size="sm" title="Template" centered @ok.prevent="saveTemplate">
      <b-form ref="formSaveTemplate" @submit.prevent="saveTemplate">
        <b-input ref="inputTemplateName" v-model="templateName" placeholder="Template Name" required trim minLength="3"/>
      </b-form>
    </b-modal>

    <b-modal v-model="modalEditTemplate" button-size="sm" title="Template" centered @ok.prevent="editTemplate">
      <b-form ref="formEditTemplate" @submit.prevent="editTemplate">
        <b-input ref="inputTemplateNameEdit" v-model="templateName" placeholder="Template Name" required trim minLength="3"/>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: "BqTemplateHandler",
  props: {
    selectedTable: Object,
    currentQueryModel: Object,
    templates: Array,
    currentTemplate: Object
  },
  data() {
    return {
      modalSaveTemplate: false,
      modalEditTemplate: false,
      templateName: '',

      selectedTemplate: null
    }
  },
  computed: {
    filteredTemplates() {
      let i = 0;
      let allGroups = [];
      let maxLevel = 0;

      _.each(this.templates, (t) => {
        let arr = t.bqTemplateName.split('/');
        for (i = 0; i < arr.length - 1; i++) {
          let node = {
            id: `${arr[i]}|${i}`,
            label: arr[i],
            level: i,
            children: [],
            parent: null
          };
          if (i > 0) {
            node.parent = {
              id: `${arr[i - 1]}|${i - 1}`
            }
          }
          allGroups.push(node);

          if (i > maxLevel)
            maxLevel = i;
        }
      });

      let groups = _.uniqWith(allGroups, _.isEqual);

      _.each(this.templates, (t) => {
        let arr = t.bqTemplateName.split('/');
        let node = {
          id: t.id,
          label: arr[arr.length - 1],
          name: t.bqTemplateName,
        };

        if (arr.length === 1) {
          groups.push(node)
        } else {
          let level = arr.length - 2;
          let group = _.find(groups, {label: arr[level], level: level});
          group.children.push(node)
        }
      });

      for (i = maxLevel; i > 0; i--) {
        let children = _.remove(groups, {level: i});
        _.each(children, (c) => {
          if (c.parent) {
            let parent = _.find(groups, {id: c.parent.id});
            parent.children.push(c);
          }
        })
      }

      return groups;
    },
  },
  methods: {
    emitSelectedTemplate() {
      if (this.selectedTemplate) {
        this.$emit('selectedTemplate', _.find(this.templates, {id: this.selectedTemplate}))
      }
    },
    confirmEditTemplate() {
      this.templateName = this.currentTemplate.bqTemplateName;
      this.modalEditTemplate = true;
    },
    confirmSaveTemplate() {
      this.templateName = '';
      this.modalSaveTemplate = true;
    },
    saveTemplate() {
      const form = this.$refs['formSaveTemplate'];

      if (!form.reportValidity()) {
        return;
      }

      const inputTemplateName = this.$refs['inputTemplateName'];
      
      if (_.some(this.templates, {bqTemplateName: this.templateName})) {
        inputTemplateName.setCustomValidity('Template Name already exist');
        return
      } else {
        inputTemplateName.setCustomValidity('');
      }

      this.$bvModal.msgBoxConfirm(
          'Proceed to save template?',
          {centered: true}
      ).then(async (confirm) => {
        if (confirm) {

          this.$emit('saveTemplate', {
            templateName: this.templateName,
            callback: () => {
              this.modalSaveTemplate = false;
            }
          })
        }
      })
    },
    editTemplate() {
      const form = this.$refs['formEditTemplate'];

      if (!form.reportValidity()) {
        return;
      }

      const inputTemplateName = this.$refs['inputTemplateNameEdit'];
      const templateWithSameName = _.find(this.templates, {bqTemplateName: this.templateName});
      if (templateWithSameName && templateWithSameName.id !== this.currentTemplate.id) {
        inputTemplateName.setCustomValidity('Template Name already exist');
        return
      } else {
        inputTemplateName.setCustomValidity('');
      }

      this.$bvModal.msgBoxConfirm(
          'Proceed to edit template?',
          {centered: true}
      ).then(async (confirm) => {
        if (confirm) {
          this.$emit('editTemplate', {
            id: this.currentTemplate.id,
            templateName: this.templateName,
            callback: () => {
              this.modalEditTemplate = false;
            }
          })
        }
      })
    },
    removeTemplate() {
      this.$bvModal.msgBoxConfirm(
          'Proceed to delete template?',
          {centered: true}
      ).then(async (confirm) => {
        if (confirm) {
          this.$emit('removeTemplate')
        }
      }).finally(() => {
        this.selectedTemplate = null
      })
    }
  }
}
</script>


<style scoped>

</style>